import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18N, GlobalContext } from 'commons';

const Header = ({ minRequired, isAllFieldMandatory }) => {
  const { lang } = useContext(GlobalContext);
  return (
    <div className="pb-2">
      <h3
        className="h3-gray mt-5 pb-0"
      >
        <I18N>new.registration.signup.create.account.label.contactInformation</I18N>
      </h3>
      <span className="form-text" id="contactInformationHelp">
        <I18N>new.registration.signup.create.account.contact.help</I18N>
      </span>
      {!isAllFieldMandatory && minRequired > 0 &&
        <p className="content pt-2" dir={lang === 'ar_SA' ? 'rtl' : 'ltr'}>
          <I18N>{`new.registration.ssp.path.complete.at.least, ${minRequired}`}</I18N>
        </p>
      }
    </div>
  );
};

Header.propTypes = {
  mandatory: PropTypes.bool.isRequired,
  minRequired: PropTypes.number.isRequired,
  isAllFieldMandatory: PropTypes.bool.isRequired
};

export default Header;
